import { render, staticRenderFns } from "./NewChatPermissionBanner.vue?vue&type=template&id=1c469bd8"
import script from "./NewChatPermissionBanner.vue?vue&type=script&lang=js"
export * from "./NewChatPermissionBanner.vue?vue&type=script&lang=js"
import style0 from "./NewChatPermissionBanner.vue?vue&type=style&index=0&id=1c469bd8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports